import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useStoreState } from 'easy-peasy';
import Layout from '../../../components/global/Layout';
import InvoiceHeader from './InvoiceHeader';
import KraveinToggle from './KraveinToggle';
import OrdersTable from './OrdersTable';
import OrderDrawer from './OrderDrawer';
import PlacesBreakdown from './PlacesBreakdown';
import InvoiceNotes from './InvoiceNotes';
import { useOrderInvoiceSummary } from './hooks/useOrderInvoiceSummary';
import { useGenerateRctiInvoice } from './hooks/useGenerateRctiInvoice';
import styles from './PaymentInvoice.module.css';

const PaymentInvoice = ({ match, history }) => {
  const { companyInvoiceId } = match.params;
  const { userId } = useStoreState(state => state.auth);

  const { status: summaryStatus, invoice } = useOrderInvoiceSummary(
    userId,
    companyInvoiceId,
  );

  const {
    rctiStatus,
    generatingPlaceId,
    generate: generateRcti,
  } = useGenerateRctiInvoice();

  const [showKravein, setShowKravein] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  return (
    <Layout>
      <div className={styles.wrapper}>
        {/* Topbar */}
        <div className={styles.topbar}>
          <div className={styles.topbarLeft}>
            <button
              className={`button ${styles.btn} ${styles.btnSecondary} ${styles.btnBack}`}
              onClick={() => history.goBack()}
            >
              ← Back
            </button>
          </div>
        </div>

        <InvoiceHeader invoice={summaryStatus === 'loading' ? null : invoice} />

        {/* {invoice?.places?.length > 0 && (
          <PlacesBreakdown
            places={invoice.places}
            period={invoice.period}
            generatingPlaceId={generatingPlaceId}
            rctiStatus={rctiStatus}
            onGenerateRcti={generateRcti}
          />
        )} */}

        <KraveinToggle
          showKravein={showKravein}
          onChange={e => setShowKravein(e.target.checked)}
        />
        <OrdersTable
          userId={userId}
          companyInvoiceId={companyInvoiceId}
          period={invoice?.period}
          showKravein={showKravein}
          onSelectOrder={setSelectedOrder}
        />
        <InvoiceNotes
          pdfS3Key={invoice?.pdfS3Key}
          paymentDate={invoice?.paymentDate}
        />
        {selectedOrder && (
          <OrderDrawer
            order={selectedOrder}
            showKravein={showKravein}
            onClose={() => setSelectedOrder(null)}
            userId={userId}
          />
        )}
      </div>
    </Layout>
  );
};

export default withRouter(PaymentInvoice);
